'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _draftJs = require('draft-js');

var _draftjsConstants = require('../../draftjsConstants');

exports.default = function (event, _ref) {
    var getProps = _ref.getProps;

    var _getProps = getProps(),
        createNewCard = _getProps.createNewCard,
        saveCurrentContent = _getProps.saveCurrentContent;

    if (createNewCard && (_draftJs.KeyBindingUtil.hasCommandModifier(event) || _draftJs.KeyBindingUtil.isCtrlKeyCommand(event))) {
        saveCurrentContent();
        (0, _lodash.defer)(function () {
            return createNewCard();
        });
        return _draftjsConstants.HANDLER_RETURN_VALUES.handled;
    }
    return _draftjsConstants.HANDLER_RETURN_VALUES.notHandled;
};

// Constants
// Lib


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/milanoteShortcuts/handleReturn.js
// module id = 1740
// module chunks = 0